<!--
  This icon is designed especially for Dierenbescherming and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M22.2.2H1.8C.8.2 0 1 0 1.9v20.2c0 .9.8 1.7 1.8 1.7h20.5c1 0 1.8-.8 1.8-1.7V1.9C24 1 23.2.2 22.2.2zM7.1 20.3H3.6V9h3.6v11.3zM5.3 7.5c-1.1 0-2.1-.9-2.1-2s.9-2 2.1-2c1.1 0 2.1.9 2.1 2s-.9 2-2.1 2zm15.2 12.8h-3.6v-5.5c0-1.3 0-3-1.9-3s-2.1 1.4-2.1 2.9v5.6H9.4V9h3.4v1.5c.5-.9 1.6-1.8 3.4-1.8 3.6 0 4.3 2.3 4.3 5.4v6.2z"
    />
  </svg>
</template>
